module.exports = __webpack_public_path__ + "img/vip.cdedc2b5.png";